<template>
  <div>
    <v-tabs
      v-model="proxyModel"
      v-bind="$attrs"
      :class="barClass"
      v-on="forwardedListeners"
    >
      <v-tab
        v-for="(tab, index) in tabs"
        :key="index"
        :class="tabClass"
      >
        {{ tab.title }}
      </v-tab>
    </v-tabs>
    <v-tabs-items
      v-model="proxyModel"
      :class="contentClass"
    >
      <slot />
    </v-tabs-items>
  </div>
</template>

<script>
// Renders the tabs bar and the tab content (two siblings sharing one model).
// Tab titles come from the `tabs` prop; tab content comes in as EkitabuTabItem
// slot children. Vuetify 3 cutover: v-tabs-items -> v-window, and the slotted
// EkitabuTabItem becomes v-window-item (handled in those two files).
export default {
  name: "EkitabuTabs",
  inheritAttrs: false,
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [Number, String],
      default: 0,
    },
    barClass: {
      type: [String, Array, Object],
      default: "",
    },
    tabClass: {
      type: [String, Array, Object],
      default: "",
    },
    contentClass: {
      type: [String, Array, Object],
      default: "",
    },
  },
  computed: {
    proxyModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    // Forward any other listeners to v-tabs, but not `input` — that channel is
    // owned by proxyModel, so forwarding it too would double-fire the model.
    forwardedListeners() {
      // eslint-disable-next-line no-unused-vars
      const { input, ...rest } = this.$listeners;
      return rest;
    },
  },
};
</script>
